import { Component } from '@angular/core';
import { TitlePagesComponent } from '../../../shared/components/title-pages-component/title-pages-component';
import { RouterOutlet, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reportes-component',
  standalone: true,
  imports: [TitlePagesComponent, RouterOutlet],
  templateUrl: './reportes-component.html',
  styleUrl: './reportes-component.scss',
})
export class ReportesComponent {
  protected pageData = {
    title: 'Reportes',
    subTitle: 'Bienvenido al sistema de gestión NOM-035',
  };

  constructor(private route: ActivatedRoute) {}

  get showParentTitle(): boolean {
    return !this.route.firstChild; // true si NO hay hija activa
  }
}
